import { TReservationStatuses } from 'modules/settings/models';
import API from 'services/api';

export const getReservationStatuses = (): Promise<TReservationStatuses[]> =>
  API.get('api/accommodation/calculation-statustypes').then(response => response?.data);
